import { useEffect, useState } from 'react'

import { GET_ACTIVE_PERIODS } from 'graphql/queries'

import { graphqlClient, handleGraphQLErrorsWithToast, redirectToHome } from 'utils'

interface IPeriod {
  listPeriods?: {
    id: string
    year: number
  }[]
}
const useCurrentPeriod = () => {
  const [periods, setPeriods] = useState<IPeriod>({})
  const getActivePeriods = async () => {
    try {
      const { data } = await graphqlClient().query({
        query: GET_ACTIVE_PERIODS,
      })
      setPeriods(data)
    } catch (e) {
      handleGraphQLErrorsWithToast(
        e,
        'Não foi possível carregar os períodos ativos. Tente novamente mais tarde.',
      )
      redirectToHome()
    }
  }

  useEffect(() => {
    getActivePeriods()
  }, [])

  return { periods }
}
export default useCurrentPeriod
